import * as types from './passwords.types';
import * as constants from './passwords.constants';
import { IPasswordSearchParams } from '../../resource/password/password.types';

export const initialPasswordsPage = (searchParams: IPasswordSearchParams): types.IInitialPasswordsPage => ({
  type: constants.INITIAL_PASSWORDS_PAGE,
  payload: searchParams,
});
